export default "__VITE_ASSET__kbn8lkBT__"